Directives.FileCommentsDirective = function FileCommentsDirective() {

    // @ngInject
    function FileCommentsDirectiveControllerFunc(UsersManager, $filter, $timeout) {
        this.UsersManager = UsersManager;
        this.$filter = $filter;
        this.$timeout = $timeout;

        this.currentUser  = UsersManager.getCurrUser();
        this.comments = [];
        this.newCommentText = '';
        this.isDraft = this.fileModel.isDraft();

        if (!this.hideDrawerMethod) {
            this.hideDrawerMethod = function hideDrawerMethod() {
                this.hideDrawerProperty = false;
            };
        }

        if (!this.scrollToBottom) {
            this.scrollToBottom = function scrollToBottom(speed) {
                var container      = angular.element('#js-file-comments-container');
                var comments       = angular.element('#js-file-comments');
                var commentsHeight = comments.height();

                if (commentsHeight > container.height()) {
                    container.animate({scrollTop: commentsHeight}, speed);
                }
            };
        }
    }

    var FileCommentsDirectiveController = Class(Controllers.BaseController, {
        constructor: FileCommentsDirectiveControllerFunc,

        addComment: function addComment() {
            if (this.newCommentText.length > 0) {
                this.fileModel.addComment(this.newCommentText);
                this.clearCommentText();
            }

            this.$timeout(function() {
                this.scrollToBottom('slow');
            }.bind(this), 500);
        },


        getCommenter: function getCommenter(comment) {
            return this.fileModel.feed.feed_users[comment.sender_id];
        },

        clearCommentText: function clearCommentText() {
            this.newCommentText = '';
        },

        allowedToComment: function allowedToComment() {
            return !this.fileModel.isDraft() && this.workspaceModel && this.workspaceModel.isMemberInWorkspace(this.currentUser._id);
        },

        textareaPlaceholder: function textareaPlaceholder() {
            if (this.workspaceModel && !this.workspaceModel.isMemberInWorkspace(this.currentUser._id)) {
                return "FILE.COMMENTS._ONLY_WORKSPACE_MEMBERS_PLACEHOLDER_";
            } else if (this.fileModel.isDraft()) {
                return "FILE.COMMENTS._DRAFT_";
            } else {
                return "FILE.COMMENTS._NEW_COMMENT_PLACEHOLDER_";
            }
        }

    });

    return {
        scope: {
            fileModel: '=fileModel',
            workspaceModel: '=workspaceModel',
            hideDrawerMethod: '=?hideDrawerMethod',
            hideDrawerProperty: '=?hideDrawerProperty',
            scrollToBottom: '=?scrollToBottom'
        },
        templateUrl: 'angular/app/modules/core/features/workspace_file/file_comments/file_comments_directive_template.html',
        controller: FileCommentsDirectiveController,
        controllerAs: 'fileCommentsVm',
        bindToController: true
    };
};